import { useState } from 'react';
import styled from 'styled-components';

import { VFlex } from '@/components/base';
import Input from '@/components/Inputs/Input';
import Modal, { useModalContext } from '@/components/Modal/Modal';
import { modalStyle } from '@/styles/style';

type Props = {
  initialInput: string;
  onDone: (name: string) => void;
};

const AnalysisBoxRenameModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const [name, setName] = useState(props.initialInput);
  const onDoneClick = () => {
    props.onDone(name);
    closeModal();
  };
  return (
    <Style>
      <Modal.Header>
        <Modal.Title>Rename Smart brief</Modal.Title>
      </Modal.Header>
      <Modal.Body className="flex flex-col gap-4">
        <Input
          placeholder="Enter new name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sizeType="m"
        />
      </Modal.Body>
      <Modal.Footer
        cancel={{
          onClick: closeModal,
        }}
        confirm={{
          children: 'Done',
          onClick: onDoneClick,
        }}
      />
    </Style>
  );
};

const Style = styled(VFlex)`
  width: 500px;
  ${modalStyle};
`;

export default AnalysisBoxRenameModal;
